import React, {useState} from 'react';
import {agent} from '../../api/agent';

/** Draft plaintext stays outside the pipeline JSON until encryption succeeds. */
export default function SecretField({label, value, onChange}: {
    label: string; value: string; onChange: (value: string) => void;
}) {
    const [draft, setDraft] = useState('');
    const [busy, setBusy] = useState(false);
    const [error, setError] = useState('');
    return <div>
        <label>{label}
            <input type="password" autoComplete="new-password" value={draft} disabled={busy}
                   placeholder={value ? 'Encrypted value saved; enter a replacement' : 'Enter credential'}
                   onChange={e => setDraft(e.target.value)} />
        </label>
        <button type="button" disabled={busy || !draft} onClick={async () => {
            setBusy(true);
            setError('');
            try {
                const encrypted = draft.startsWith('ENC[v1]:') ? draft : (await agent.encrypt(draft)).encryptedData;
                if (!encrypted?.startsWith('ENC[v1]:')) throw new Error('Encryption failed');
                onChange(encrypted);
                setDraft('');
            } catch {
                setError('Could not encrypt credential. Please try again.');
            } finally { setBusy(false); }
        }}>{busy ? 'Encrypting…' : 'Encrypt and apply'}</button>
        {value && <span> Encrypted credential configured.</span>}
        {draft && <div>Click Encrypt and apply to include this credential in the pipeline.</div>}
        {error && <div role="alert">{error}</div>}
    </div>;
}
